import React from 'react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { observer as observerLite } from 'src/utils/mobx-react';
import {
    EventRowSelections,
    EventRowSelectionsName,
    EventRowSelectionsElement,
    EventRowSingleSelection,
} from 'src/domains/sportsbook/webview/components/eventsList/eventRow6Pack/EventRowSelectionsGroup.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface SelectionsGroupPropsType {
    market?: MarketModel;
    marketTypeName?: string;
    getSelectionNameCallback: (market: MarketModel | undefined, selection: SelectionModel) => string;
}

export const SelectionsGroup = observerLite<SelectionsGroupPropsType>('SelectionsGroup', (props) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { sportsbookVariant } = configState.componentVariants;
    const { market, marketTypeName = '-', getSelectionNameCallback } = props;

    if (market === undefined) {
        return (
            <EventRowSelections variant={sportsbookVariant}>
                <EventRowSelectionsName variant={sportsbookVariant}>{marketTypeName}</EventRowSelectionsName>
            </EventRowSelections>
        );
    }
    return (
        <EventRowSelections variant={sportsbookVariant}>
            <EventRowSelectionsName variant={sportsbookVariant}>{marketTypeName}</EventRowSelectionsName>
            {market.selections.map((selection) => {
                return (
                    <EventRowSelectionsElement
                        key={selection.id2.toOldId()}
                        variant={sportsbookVariant}
                    >
                        <EventRowSingleSelection
                            showParticipantName={getSelectionNameCallback(market, selection)}
                            selectionId={selection.id2}
                            borderLeft={true}
                            borderRight={true}
                            borderBottom={true}
                        />
                    </EventRowSelectionsElement>
                );
            })}
        </EventRowSelections>
    );
});
